var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition-panel",class:{hidden: !_vm.visible, left: _vm.left}})
}
var staticRenderFns = []

export { render, staticRenderFns }